<template>
  <div class="contract-detail-chart">
    <div class="contract-detail-table">
      <vxe-toolbar v-if="showSupplement || showRelation" size="small">
        <template v-slot:buttons>
          <el-button
            v-if="showSupplement"
            @click="createSupplement"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >新增结算条款</el-button
          >
          <el-button
            v-if="showRelation"
            @click="relateProject"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >关联项目</el-button
          >
          <el-button
            v-if="showDelete"
            @click="deleteRelation"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >删除关联</el-button
          >
        </template>
      </vxe-toolbar>
      <sirui-table
        ref="siruiTable"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :auto-resize="true"
        :buttonList="getButtonList"
        :showToolbar="false"
        resizable
        :columns="getChartColumns"
        :cellStyle="cellStyle"
        :cellClick="cellClick"
        @handleSelectionChange="handleSelectionChange"
        @handleSizeChange="() => getData()"
        @handleCurrentChange="() => getData()"
        height="300"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in getChartColumns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
        >
          <template slot-scope="scope">
            <span
              v-if="
                item.field == 'contractSignDate' ||
                item.field == 'contractEffectDate' ||
                item.field == 'contractExpireDate'
              "
            >
              {{ formatDateCustom(scope.row[item.field], false) }}</span
            >
            <span v-else-if="item.field == 'contractType'">{{
              getContractType(scope.row[item.field])
            }}</span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
      <SelectProjectDialog
        ref="projectSearchRef"
        title="关联项目-选择项目"
        confirmText="关联项目"
        :extraData="getExtraData"
        :api="getApi()"
        @confirm="selectProjectHandler"
      ></SelectProjectDialog>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import SelectProjectDialog from '../../../overview/SelectProjectDialog.vue';
  import CONTRACTAPI from '@/api/intermodality/contract';

  export default {
    name: 'AssociatedContractDetailChart',
    mixins: [IntermodalityCommonMixin],
    components: {
      SelectProjectDialog,
    },
    props: {
      //customer or supplier
      chartType: {
        type: String,
        default: () => 'customer',
      },
      contractType: {
        type: String,
        default: () => '',
      },
      contractStatus: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        loading: false,
        contractCode: null,
        tableData: [],
        selection: [],
        btnType: '', //判断是否为编辑纸质合同号按钮跳转过来，若是则详情只能编辑纸质合同号
      };
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.contractCode = this.$route.query?.contractCode;
      this.btnType = this.$route.query?.btnType;
      this.getData();
    },
    methods: {
      getApi() {
        return CONTRACTAPI.RELATED_PROJECT_LIST;
      },
      //选中触发事件
      handleSelectionChange(row) {
        this.selection = row;
        console.log(row);
      },
      cellClick(val) {
        if (val.column?.property == 'projectCode') {
          this.toProjectDetail(val.row.projectCode);
        } else if (val.column?.property == 'contractCode') {
          console.log('clickContract', val);
          let isCustomerContract = val.row.contractDataType == 'C';
          let code = val.row.contractCode;
          this.toContractDetail(code, isCustomerContract);
        }
      },
      toProjectDetail(projectCode) {
        let query = {
          origin: 'detail',
          projectCode: projectCode,
          pageMode: 1,
        };

        let path = {
          path: '/intermodality/projectDetail',
          name: 'projectDetail',
          meta: {
            keepAlive: false,
            title: '项目详情',
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      toContractDetail(contractCode, isCustomerContract) {
        let suffix = '';
        let name = '';
        let query = { contractCode, origin: 'detail', pageMode: 1 };

        if (isCustomerContract) {
          suffix = 'customerContractDetail';
          name = '客方合同详情';
        } else {
          suffix = 'supplierContractDetail';
          name = '供方合同详情';
        }

        let path = {
          path: '/intermodality/' + suffix,
          name: suffix,
          meta: {
            keepAlive: true,
            title: name,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      getContractType(type) {
        if (type == 0) {
          return '常规合同';
        } else if (type == 1) {
          return '结算条款';
        }
        return type;
      },
      cellStyle({ row, rowIndex, column, columnIndex }) {
        if (column.property == 'projectCode' || column.property == 'contractCode') {
          console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
            cursor: 'pointer',
          };
        }
      },
      deleteRelation() {
        if (this.selection.length == 1) {
          this.$confirmAction('删除关联明细', '是否确定要删除该关联明细？', '确认', '取消')
            .then(async () => {
              let contractCode = this.contractCode;
              let projectCode = this.selection[0].projectCode;
              let projectName = this.selection[0].projectName;
              let params = {
                contractCode,
                projectCode,
                projectName,
              };
              var res = await this.$axios.post(CONTRACTAPI.DELETE_RELATION, params);
              this.completeRelation(res);
              // }
            })
            .catch((e) => {
              console.log('deleteError', e);
              this.$message({
                type: 'info',
                message: '已取消',
              });
            });
        } else {
          this.$message({
            type: 'error',
            message: '请选择一条关联明细',
          });
        }
      },
      async getData() {
        if (!this.contractCode || !this.contractCode.length) {
          return;
        }
        let params = {
          contractCode: this.contractCode,
          contractDataType: this.chartType == 'customer' ? 'C' : 'S',
        };
        setTimeout(async () => {
          params.pageNum = this.$refs.siruiTable?.page?.pageNum;
          params.pageSize = this.$refs.siruiTable?.page?.pageSize;
          let data = await this.$axios.post(CONTRACTAPI.ASSOCIATED_LIST, params);
          console.log('associatedList', data);
          if (data) {
            let list = data.data.data;
            // let pageNum = data.data.data.pages;
            // let total = data.data.data.total;
            this.tableData = list || [];
            // this.$refs.siruiTable.setPageTotal(total);
            // this.$refs.siruiTable.setPageSize(pageNum);
          }
        }, 500);
      },
      createSupplement() {
        this.$emit('createSupplement');
      },
      relateProject() {
        this.$refs.projectSearchRef.openModal();
      },

      completeRelation(res) {
        if (res.data.code == 0) {
          let data = res.data.data;
          let projectCodeList = data.projectCodeList;
          let projectNameList = data.projectNameList;
          console.log('relateData', data);
          console.log('relateSend', projectCodeList, projectNameList);

          this.$emit('relateComplete', projectCodeList, projectNameList);
          this.getData();
          this.$message.success('关联成功');
        } else {
          this.$message.error(res.data.msg);
        }
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selection = [];
      },
      async selectProjectHandler(row) {
        let projectCode = row.projectCode;
        let projectName = row.projectName;
        let params = {
          projectCode,
          projectName,
          contractCode: this.contractCode,
        };
        let res = await this.$axios.post(CONTRACTAPI.RELATE_PROJECT, params);
        this.completeRelation(res);
      },
    },
    computed: {
      getButtonList() {
        return [];
      },
      getChartColumns() {
        return chartColumns;
      },
      showDelete() {
        return (
          this.chartType != 'customer' &&
          this.getStatusName('contract', this.contractStatus) == '已生效' &&
          this.btnType != 'editContractNo'
        );
      },
      showSupplement() {
        return (
          this.getStatusName('contract', this.contractStatus) == '已生效' &&
          this.contractType != '1' &&
          this.btnType != 'editContractNo'
        );
      },
      showRelation() {
        return (
          this.chartType != 'customer' &&
          this.getStatusName('contract', this.contractStatus) == '已生效' &&
          this.btnType != 'editContractNo'
        );
      },
      getExtraData() {
        return {
          contractCode: this.contractCode,
          contractType: this.contractType,
          projectStatus: ['xmzt03', 'xmzt05'],
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .contract-detail-chart {
    background: #fff;

    .contract-detail-table {
      box-sizing: border-box;
      padding: 10px;
      box-sizing: border-box;
    }
  }
</style>
